"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeableConcept = void 0;
/**
 * A concept that may be defined by a formal reference to a terminology or ontology or may be provided by text.
 */
var CodeableConcept = /** @class */ (function () {
    function CodeableConcept() {
    }
    return CodeableConcept;
}());
exports.CodeableConcept = CodeableConcept;
